import { create } from "zustand";

/**
 * Thin module-level store for the offers inbox count. Populated by OffersPage
 * after its `getOffersInbox` call — the single canonical read. DesktopSidebar
 * and MobileSidebar read the count for the Your Offers badge without adding a
 * second fetch (Decision 232).
 *
 * count: null = not yet fetched (badge hidden)
 * count: 0    = fetched, empty inbox (badge shows 0)
 * count: n    = fetched, n live offers (badge shows n)
 */
interface OffersState {
  count: number | null;
  setCount: (count: number) => void;
}

export const useOffersStore = create<OffersState>((set) => ({
  count: null,
  setCount: (count) => set({ count }),
}));
